//Comentario necesario para codificación en UTF-8, ver Inc6743

(function () {
	angular.module('pphhApp')
	.controller("myDownloadController", ["$scope", "$window", "MyDownloadService", "CommonCatalogService",
		"pphhEnv", MyDownloadController]);
	
	function MyDownloadController($scope, $window, myDownloadService, commonCatalogService, pphhEnv) {
	
		$scope.waterModule = "";

		$scope.waterModules = [];
		$scope.filterResults = [];
		
		$scope.init = init;
		$scope.clearFilter = clearFilter;
		$scope.doFilter = doFilter;
		$scope.navigate = navigate;

		function init() {
			commonCatalogService.getWaterModulesNoAux()
			.then(function (response) {
				$scope.waterModules.push({"key":"", "value":""})
				$scope.waterModules = $scope.waterModules.concat( response.data );
				
			});
		}

		function clearFilter() {
			$scope.waterModule = "";
			var form = $scope.filterForm;
			form.$setPristine();

			if($scope.stCtrl) {
				$scope.filterResults = [];
				$scope.stCtrl.pipe();
			}
			doFilter();
		}

		function doFilter() {

			myDownloadService.getPendingTasks($scope.waterModule)
			.then(
				function(response) {
					$scope.filterResults = response.data;
				},
				function() {
					$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error get",
								ok: UIMessages.dialog.confirm.cerrar
							}));
				}
			);
		}

		function navigate(row) {
			var id = row.id;
			var url = pphhEnv.global.contextPath + "/myDownload/access/" + id;
			$window.location.href = url;
		}
	}
})();